import React, { useEffect, useState } from "react";
import "../App.scss";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  Outlet,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  FloatingButton,
  Text,
  SwipeTabs,
  SwipeTab,
} from "../styles/Global";
import * as Global from "../styles/Global";
import {
  Menu,
  Item,
  Separator,
  Submenu,
  MenuProvider,
  useContextMenu,
  animation,
} from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import { AiFillCloseCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { SVGIcon } from "./CustomSVG";
import SlideUp from "./modals/SlideUp";
import { setModal } from "../features/modals/modalSlice";
import * as momentTZ from "moment-timezone";
import { BsShieldShaded } from "react-icons/bs";
import { OrgAssistIcon } from "../assets/sport/icons/orgAssistIcon";
import CircularProgress from "./ProgressBars/CircularProgress";
import HelipadIcon from "../assets/icons/HelipadIcon";

const mapDispatch = { setModal };

const GridFindTournamentCustomEvents = ({ data, setModal }) => {
  // console.log("Grid Find Tournament custom events data: ", data);
  const eventData = data;
  const [displayModal, setDisplayModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const params = new URLSearchParams(window.location.search);
  const darkMode = useSelector((state) => state.global.darkMode);
  const hasRestrictions =
    data.hasOwnProperty("restrictionsCount") && data.restrictionsCount > 0;
  const isHandicap =
    data.hasOwnProperty("handicap") && data.handicap.enabled;
  const localFilter =
    JSON.parse(localStorage.getItem("findTournamentFilters")) || {};
  console.log("gridFindTournament darkMode: ", darkMode);
  // console.log("GridFindTournamentCustomEvents eventData: ", eventData);
  const { show } = useContextMenu({
    id: eventData.gameid,
  });

  function handleItemClick() {
    // setModal({ organizerEvent: { showModal: true, data: eventData } });
    console.log("item clicked: ", eventData);
  }

  function SetEventColor(opacity) {
    let color = "#fff";
    switch (eventData.teamcreate) {
      case "Singles":
        color = opacity === 99 ? "#d07a2d" : `#d07a2d${opacity}`;
        break;
      case "Blind Draw":
        color = opacity === 99 ? `#43922a` : `#43922a${opacity}`;
        break;
      case "Set Teams":
        color = opacity === 99 ? `#3576a4` : `#3576a4${opacity}`;
        break;
      case "Switcholio":
        color = darkMode
          ? opacity === 99
            ? `#895ADB`
            : `#895ADB${opacity}`
          : `#4b3179${opacity}`;
        break;
      case "Split Switch":
        color = opacity === 99 ? `#CC0C0D` : `#CC0C0D${opacity}`;
        break;
      case "Squadholio":
        color = opacity === 99 ? `#bb9b34` : `#bb9b34${opacity}`;
        break;
      case "MultiMatch":
        color = darkMode
          ? opacity === 99
            ? `#9a8f83`
            : `#9a8f83${opacity}`
          : `#5D3911${opacity}`;
        break;
      default:
        color = `#333${opacity}`;
        break;
    }
    return color;
  }

  return (
    <>
      {displayModal && (
        <SlideUp
          setDisplayModal={setDisplayModal}
          modalData={eventData}
          modalType={12}
        />
      )}
      <FlexColumn
        className="eventListItem"
        style={{
          // flex: 1,
          // width: "100%",
          // padding: 5,
          // margin: "0 3px",
          // backgroundColor: "#fff",
          backgroundColor: SetEventColor(20),
          marginBottom: 13,
          marginTop: 3,
          border: "1px solid #949CC160",
          borderColor: SetEventColor(99),
          position: "relative",
          cursor: "pointer",
        }}
        onClick={handleItemClick}
        id={eventData.gameid}
      >
        <FlexRow
          justify="space-between"
          align="flex-start"
          style={{ alignSelf: "stretch" }}
        >
          <FlexRow align="center" style={{ flex: 0 }}>
            {SVGIcon(eventData, SetEventColor)}
            <FlexColumn style={{ flex: 0 }}>
              <Text
                size=".9em"
                color={SetEventColor(99)}
                style={{
                  fontWeight: "900",
                  marginTop: 2,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  marginBottom: 0,
                  padding: 0,
                  textShadow: `0 1px 0px rgba(0,0,0,.1)`,
                }}
              >
                {eventData.teamcreate}
              </Text>
              <Text
                size=".7em"
                color={SetEventColor(99)}
                style={{
                  textShadow: `0 1px 0px rgba(0,0,0,.1)`,
                  textTransform: "uppercase",
                }}
              >
                {eventData.format}
              </Text>
            </FlexColumn>
            {eventData.type === "Test" && (
              <div
                style={{
                  padding: "0 3px 2px",
                  borderRadius: 20,
                  marginLeft: 5,
                  background: Global.redLight,
                  boxShadow: "0 2px 2px rgba(0,0,0,.3)",
                }}
              >
                <Text
                  size=".7em"
                  color="#fff"
                  style={{
                    fontWeight: "800",
                    lineHeight: ".7em",
                  }}
                >
                  TEST
                </Text>
              </div>
            )}
          </FlexRow>
          <FlexColumn align="flex-end" style={{ marginTop: 1, flex: 1 }}>
            <Text
              size=".9em"
              style={{
                paddingRight: 5,
                whiteSpace: "normal",
                textAlign: "right",
              }}
            >
              {/* {moment(eventData.gametime, "X").format("ddd, M/D/YY h:mma")} */}
              {eventData.hasOwnProperty("timezone") && eventData.hasOwnProperty("gametime") && eventData.gametime && eventData.timezone
                ? moment(eventData.gametime, "X")
                    .tz(eventData.timezone)
                    .format("ddd, MMM D, YYYY h:mma z")
                : "No Date"}
            </Text>
            <FlexRow
              align="center"
              justify="flex-end"
              style={{ flex: 1, paddingRight: 5 }}
            >
              <>
                <Text
                  size=".9em"
                  // color={SetEventColor(99)}

                  style={{ fontWeight: "800" }}
                >
                  {!eventData.gameregistered
                    ? 0
                    : eventData.gamemaxteams > 0
                    ? `${eventData.gameregistered}/${eventData.gamemaxteams}`
                    : `${eventData.gameregistered}`}
                </Text>
                <Text size=".9em" style={{ marginLeft: 2 }}>
                  Reg
                </Text>
              </>
              <>
                <Text size=".9em" style={{ padding: "0 2px" }}>
                  -
                </Text>
              </>
              {eventData.waitlistCount && eventData.waitlistCount > 0 ? (
                <>
                  <>
                    <Text
                      size=".9em"
                      // color={SetEventColor(99)}

                      style={{ fontWeight: "800" }}
                    >
                      {eventData.waitlistCount}
                    </Text>
                    <Text size=".9em" style={{ marginLeft: 2 }}>
                      Wait
                    </Text>
                  </>
                  <>
                    <Text size=".9em" style={{ padding: "0 2px" }}>
                      -
                    </Text>
                  </>
                </>
              ) : null}
              <>
                <Text
                  size=".9em"
                  // color={SetEventColor(99)}

                  // style={{ fontWeight: "800" }}
                >
                  ${eventData.gameticketprice}
                </Text>
              </>
            </FlexRow>
          </FlexColumn>
        </FlexRow>
        {/* <FlexRow
          style={{ alignSelf: "stretch", padding: "0 5px", flexWrap: "wrap" }}
        > */}
        <Text
          size="1.4em"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "97%",
            margin: "5px 5px 0",
          }}
        >
          {eventData.name}
        </Text>
        <Text
          size=".9em"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "97%",
            margin: "0 5px",
            fontStyle: "italic",
            paddingBottom: 2,
            borderBottom: `1px solid ${SetEventColor(49)}`,
          }}
        >
          {eventData.locationfullname}
        </Text>
        <FlexRow
          style={{ width: "100%", paddingRight: 5, marginTop: 2 }}
          justify="space-between"
          align="center"
        >
          {eventData.organizerAssist && (
            <OrgAssistIcon
              width={20}
              height={15}
              color={Global.redLight}
              style={{ marginRight: 0 }}
            />
          )}
          <Text
            size=".9em"
            // color={SetEventColor(99)}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "97%",
              padding: "2px 5px 0",
              fontWeight: "800",
              // textAlign: "center",
            }}
          >
            {eventData.orgname ? eventData.orgname : "No Club Name"}
          </Text>
          <FlexRow align="center">
            {(params.get("location") !== "disabled" ||
              localFilter.showCustomDistance) && (
              <>
                <Text
                  size="1em"
                  // color={SetEventColor(99)}

                  style={{ fontWeight: "800" }}
                >
                  {Math.round(eventData.distance)}
                </Text>
                <Text size="1em">mi</Text>
              </>
            )}
            {hasRestrictions && (
              <BsShieldShaded
                style={{ marginLeft: 5 }}
                size={14}
                color={Global.redLight}
              />
            )}
            {isHandicap && (
              <HelipadIcon color={Global.redLight} width="17px" height="17px" style={{marginLeft: 2}}/>
            )}
          </FlexRow>
          {/* <CircularProgress
            percent={
              eventData.hasOwnProperty("progress")
                ? eventData.progress.percent || 0
                : 0
            }
            data={eventData}
            size={20}
          /> */}
        </FlexRow>
      </FlexColumn>
    </>
  );
};

export default connect(null, mapDispatch)(GridFindTournamentCustomEvents);
